<div *ngIf="hasFields"
class="search-filter-content flex-gap-5px flex-space-between flex-row flex-fill">
  <mat-form-field style="margin-top: -1px; min-width: 108px">
    <mat-select [attr.data-testid]="'search_option_select'" [formControl]="dropdownCtrl">
      <mat-option [attr.data-testid]="field.templateOptions.label + '_option'"
                  *ngFor="let field of fields; let i = index" [value]="i">
        {{ field.templateOptions.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <form  [formGroup]="form" *ngIf="!displaySearchWithOptions" class="flex-70">
    <div>
      <formly-form [form]="form.at(index)" [model]="model[index]" [fields]="selectedFields[index]"
                   [options]="options[index]" (modelChange)="modelChanged($event)">
      </formly-form>
    </div>
  </form>
  <form  *ngIf="displaySearchWithOptions" class="flex-70">
    <mat-form-field style="width: 90%; margin-left: 18px">
      <mat-label>{{searchLabel}}</mat-label>
      <input type="text"
             matInput
             [formControl]="searchForm"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="autoCompleteDisplay">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
          {{option.name}}
        </mat-option>
      </mat-autocomplete>
      <button *ngIf="searchForm.value" matSuffix mat-icon-button aria-label="Clear"
              (click)="clearSearchTerm()" [attr.data-testid]="'location_set_close_button'">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </form>
    <div  *ngIf="!addDialog" class="flex-7">
        <span></span>
    </div>
  <div  *ngIf="addDialog && (showMenu !== true) && (showAdd$ | async)" class="flex-7">
    <button class="add" [attr.data-testid]="'add_button'" mat-icon-button matTooltip="Create new record"
            (click)="add.emit()">
      <mat-icon>add_circle</mat-icon>
    </button>
  </div>
    <div *ngIf="showMenu && canAdd">
        <button class="add" [attr.data-testid]="'add_button'" mat-icon-button matTooltip="Create new record"
                (click)="add.emit()" [matMenuTriggerFor]="rightMenu">
            <mat-icon>add_circle</mat-icon>
        </button>
        <mat-menu #rightMenu="matMenu" class="add-revote-menu">
            <ng-template matMenuContent>
                <button mat-menu-item (click)="addStandard.emit()">Add Chick-fil-A, Inc. Standard Restaurants</button>
                <button mat-menu-item (click)="addCaptive.emit()">Add Captive Venues</button>
            </ng-template>
        </mat-menu>
    </div>
</div>
